module.exports = __webpack_public_path__ + "img/solution-farmer-advantage1.6ebce4ee.svg";